import React, { useState } from "react";

const faqData = [
    {
        question: "¿Qué es Reformista.net?",
        answer:
            "Reformista.net es una plataforma web pensada para ayudarte a descubrir y analizar oportunidades de inversión inmobiliaria, especialmente en viviendas que necesitan reforma. Nos centramos en propiedades ubicadas en la provincia de Granada y alrededores, con el objetivo de facilitar decisiones inteligentes basadas en datos.",
    },
    {
        question: "¿Qué tipo de propiedades puedo encontrar?",
        answer:
            'Actualmente mostramos viviendas (no locales ni terrenos) que estén marcadas como "para reformar", dentro de zonas seleccionadas y en un radio de hasta 10 km desde Granada capital.',
    },
    {
        question: "¿Qué información aparece en el listado de propiedades?",
        answer:
            "Ubicación, precio, coste estimado de reforma si lo hay, y etiquetas visuales que permiten comparar de forma rápida distintas oportunidades.",
    },
    {
        question: "¿Cómo accedo al detalle de una propiedad?",
        answer:
            "Simplemente haz clic en una propiedad del listado y verás una página con toda la información detallada: ubicación, estado, estimaciones, mapas, etc.",
    },
    {
        question: "¿Qué hace el botón 'Calcular rentabilidad'?",
        answer:
            "Muestra una estimación rápida del retorno que podrías obtener al invertir, considerando reformas mínimas o estándar.",
    },
    {
        question: "¿Qué se calcula con 'Índices de rentabilidad avanzados'?",
        answer:
            "Obtendrás el precio estimado de venta y alquiler, ROI a 1, 3, 5 y 10 años, rentabilidad anual por alquiler y tiempo estimado para recuperar la inversión, en escenarios con y sin reforma.",
    },
    {
        question: "¿Qué es el botón 'Calcular ahora'?",
        answer:
            "Este botón inicia el cálculo del escenario de alquiler vacacional: reforma premium, decoración, mobiliario, electrodomésticos y licencias.",
    },
    {
        question: "¿Cómo veo los detalles del alquiler vacacional?",
        answer:
            'Inicia sesión, ve a la propiedad que desees y pulsa “Ver Detalles Alquiler Vacacional” para ver un desglose completo de costes.',
    },
    {
        question: "¿Necesito registrarme para usar la plataforma?",
        answer:
            "No para explorar propiedades, pero sí para usar funciones como marcar favoritas, calcular rentabilidad avanzada o acceder a datos del alquiler vacacional.",
    },
    {
        question: "¿Cómo guardo propiedades favoritas?",
        answer:
            "Si has iniciado sesión, puedes hacer clic en la estrella para marcar una propiedad como favorita. Luego puedes filtrarlas fácilmente.",
    },
    {
        question: "¿Qué significan los roles al registrarme?",
        answer:
            "Puedes elegir entre Inversor, Constructor, Propietario, Perito, Interiorista o Gestor Inmobiliario, según tu perfil y necesidades.",
    },
    {
        question: "¿De dónde vienen los datos de las propiedades?",
        answer:
            "De la API oficial de Idealista. Mostramos solo propiedades en estado para reformar en zonas concretas del área metropolitana de Granada.",
    },
    {
        question: "¿Puedo filtrar y ordenar las propiedades?",
        answer:
            "Sí. Puedes aplicar filtros por zona, y ordenar por precio, reforma, habitaciones, baños o distancia al centro.",
    },
    {
        question: "¿Se muestran gráficos de rentabilidad?",
        answer:
            "Sí. Los verás al calcular los índices avanzados. Te ayudarán a comparar escenarios y entender el retorno visualmente.",
    },
    {
        question: "¿Por qué no siempre se pueden calcular los indicadores?",
        answer:
            "Si no tenemos datos de precio medio en la zona, algunos cálculos pueden no estar disponibles. Solo se mostrarán los que sean viables.",
    },
];

const FaqPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleQuestion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="max-w-4xl mx-auto p-4 bg-white rounded shadow mb-12">
            <h1 className="text-3xl font-bold text-brand-blue mb-6 text-center">Preguntas Frecuentes</h1>
            <div className="space-y-4">
                {faqData.map((item, index) => (
                    <div key={index} className="border border-gray-200 rounded">
                        <button
                            onClick={() => toggleQuestion(index)}
                            className="w-full text-left p-4 font-medium text-gray-800 hover:bg-gray-50 flex justify-between items-center"
                        >
                            {item.question}
                            <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
                        </button>
                        {openIndex === index && (
                            <div className="p-4 pt-0 text-gray-600 border-t bg-gray-50">{item.answer}</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqPage;
